class Order{
    constructor(code, client, fromId, toId, trainCarType, weight, day=0, year=0, isLate=false, isCompeted=false,
                name=null, termDelivery=2, credit=0.08, cost=null, clientName="")
    {
        this.code = code
        this.client = client
        this.fromId = fromId
        this.toId = toId
        this.trainCarType = trainCarType
        this.weight = weight
        this.day = day
        this.year = year
        this.isLate = isLate
        this.isCompeted = isCompeted
        this.name = name
        this.clientName = clientName;
        this.termDelivery = termDelivery
        this.credit = credit
        this.cost = cost;
    }
}
export default Order;